import {
  T_MeetingTranscript,
  T_PodcastDocument,
  T_ActionItems,
  T_User,
} from '@repo-sapiens/data-access-models';
export type UserSettings = {
  hasEmailNotification?: boolean;
  hasSlackNotification?: boolean;
  timeZone?: string;
  language?: string;
  createTaskShortcut?: string;
  createNoteShortcut?: string;
  location?: {
    region?: string;
    city?: string;
    country?: string;
    timezone?: string;
    postal?: string;
  };
};

type Transcript = T_MeetingTranscript & {
  _id: string;
};

export type TranscriptsResponse = {
  transcripts: Transcript[];
};
export type TranscriptResponse = {
  transcript: Omit<Transcript, 'transcript'> & { transcript: string };
};

export type SubscriptionResponse = {
  currentSubscription: Subscription;
};
export interface Subscription {
  plan: string;
  startAt?: Date;
  endAt?: Date;
  autoRenew: boolean;
  isTrial: boolean;
  billingCycle?: string;
  canceledAt?: Date;
}

export enum E_UserAction {
  SET_USER,
  SET_CURRENT_EMAIL,
  CLEAR,
}

export interface PodcastResponse {
  podcasts: T_PodcastDocument[];
}

export type T_Todo = {
  _id: string;
  title: string;
  source: string;
  sourceId?: string;
  created: Date;
  dueDate: Date;
  url?: string;
  priority: number;
};
export type TodosResponse = {
  actionItems: T_ActionItems[];
};

export interface IUser extends Partial<T_User> {
  _id: string;
  hasGmail?: boolean;
  hasCalendar?: boolean;
  hasZoom?: boolean;
}
